import { gsap, ScrollTrigger } from "../layout"

// custom library
import Choices from 'choices.js'
import axios from 'axios'

function choicesJs() {
    const element = document.querySelector('#blog-sort')

    if (element) {
        const choices = new Choices(element, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

// FUNCTION LOAD MORE
function loadMoreAjax() {
    const button = document.querySelector('.list__loadmore')
    const buttonWrapper = document.querySelector('.list__button')
    let posts_list = document.querySelector('.list__row')

    if (!button) return; // Exit function if button is not found

    if (posts_list.dataset.page == posts_list.dataset.max) {
        // button.parentNode.removeChild(button)
        buttonWrapper.classList.add('d-none')
    }

    button.addEventListener('click', (e) => {
        e.preventDefault()
        let current_page = posts_list.dataset.page
        let totalShow = document.querySelector('#total-show')

        let params = new URLSearchParams({
            action: 'load_more_blog',
            current_page: current_page,
            post_type: 'post',
            posts_per_page: 3,
            sort: defaultParams.sort,
            template_parts: 'template-parts/blog-list',
        })

        button.classList.add('disabled')
        button.innerHTML = '<div class="themeBtn__inner"><div class="dot-falling"></div></div>'

        axios.post('/wp-admin/admin-ajax.php', params)
        .then(res => {
            console.log(res);

            posts_list.innerHTML = posts_list.innerHTML + res.data.data.posts

            totalShow.innerHTML = parseInt(totalShow.textContent) + res.data.data.total_show

            posts_list.dataset.page++ // increment dataset

            button.innerHTML = '<div class="themeBtn__inner"><span>Load More</span></div>'

            ScrollTrigger.refresh() // refresh scroll

            button.classList.remove('disabled')

            // check if dataset page equal to dataset max
            // if equal, remove load more button
            if (posts_list.dataset.page == posts_list.dataset.max) {
                // button.parentNode.removeChild(button)
                buttonWrapper.classList.add('d-none')
            }
        })
    })
}

function sortingActivity() {
    const formElement = document.querySelector('#sorting-form')

    const selectElement = document.querySelector('#blog-sort')

    if (selectElement) {
        selectElement.addEventListener('change', (item) => {
            formElement.submit()
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    choicesJs()
    loadMoreAjax()
    sortingActivity()
})